import React from "react";
import { Box, Typography } from "@mui/material";
import ReportIcon from "@mui/icons-material/DescriptionOutlined";
import { floatAnimation } from "../animations";
import { FilterType, filterLabels } from "../types";

interface Props {
  activeFilter: FilterType;
}

export const EmptyJobsState: React.FC<Props> = ({ activeFilter }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: 300,
      backgroundColor: "rgba(38, 41, 59, 0.03)",
      borderRadius: 3,
      p: 4,
    }}
  >
    <Box sx={{ animation: `${floatAnimation} 3s ease-in-out infinite`, mb: 3 }}>
      <ReportIcon sx={{ fontSize: 64, color: "text.disabled" }} />
    </Box>
    <Typography variant="h6" color="text.secondary" align="center" gutterBottom>
      {activeFilter === "all" ? "No reports yet" : `No ${filterLabels[activeFilter].toLowerCase()} reports`}
    </Typography>
    <Typography variant="body2" color="text.secondary" align="center">
      {activeFilter === "all"
        ? "When you create a new report, it will appear here."
        : "Reports will appear here when their status changes."}
    </Typography>
  </Box>
);
